var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7063 2.20719L13.7922 0.293125C13.6063 0.105344 13.3501 0 13.0844 0H7.97203C6.86737 0 5.97207 0.895625 5.97207 2L5.97268 10C6.0002 11.1062 6.89705 12 8.00016 12H14C15.1 12 16 11.1 16 10V2.91406C16 2.64906 15.8938 2.39469 15.7063 2.20719ZM14.5 10C14.5 10.2761 14.2762 10.5 14 10.5H7.97203C7.69585 10.5 7.47204 10.2761 7.47204 10V2.00406C7.47204 1.72794 7.69591 1.50406 7.97203 1.50406H11.972L12.0001 3C12.0001 3.55219 12.4479 4 13.0001 4H14.4719V10H14.5ZM8.50015 14C8.50015 14.2761 8.27628 14.5 8.00016 14.5H1.97215C1.69597 14.5 1.47216 14.2761 1.47216 14L1.49966 6.00313C1.49966 5.727 1.72353 5.50313 1.99965 5.50313H5.00021V4H1.99996C0.895295 4 0 4.89531 0 6L0.000306244 14C0.000374993 15.1031 0.89592 16 2.00027 16H8.00016C9.10013 16 10.0001 15.1 10.0001 14V13H8.52827L8.50015 14Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIco);
export default __webpack_public_path__ + "static/media/copy_ico.09cab9183a6de60f576e14c888eef2e0.svg";
export { ForwardRef as ReactComponent };